import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../constants";

const handleRedirection = () => {
  const currentUrl = window.location.href;
  const urlParams = new URLSearchParams(window.location.search);

  // Prevent recursive redirection
  if (!urlParams.has("redirect")) {
    window.history.pushState({}, "", `/?redirect=${encodeURIComponent(currentUrl)}`);
    window.dispatchEvent(new PopStateEvent("popstate"));
  }
};

const customBaseQuery = async (args, api, extraOptions) => {
  const result = await fetchBaseQuery({ baseUrl: BASE_URL })(args, api, extraOptions);

  if (result?.error) {
    const { status, data } = result.error;

    if (status === 401 && ["Access token has expired", "Unauthenticated token."].includes(data?.message)) {
      handleRedirection();
    } else if (data?.data?.redirect === "/login") {
      handleRedirection();
    }
  }
  return result;
};

export default customBaseQuery;
